import { gql } from "@apollo/client";

export const onboardLensToLensCloud = gql`
    mutation onboardLensToLensCloud($lensId: ID!) {
        onboardLensToLensCloud(input: { lensId: $lensId }) {
            appId
        }
    }
`;
